import React from 'react';
import { Card, CardContent } from './ui/Card';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: "Love Outdoor Lighting completely transformed our backyard. The design was beautiful and the installation was flawless. We couldn't be happier!",
    name: 'Sarah M.',
    city: 'Chandler'
  }, {
    quote: 'Professional, on time, and the results speak for themselves. Our home looks incredible at night now.',
    name: 'Mark R.',
    city: 'Scottsdale'
  }, {
    quote: 'From the first call to the finished product, they were transparent, fair, and did amazing work. Highly recommend!',
    name: 'Jessica L.',
    city: 'Gilbert'
  }];
  return <section className="w-full bg-[var(--brand-soft-white)] py-20 lg:py-28 overflow-hidden" data-id="element-198">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        <div className="text-center mb-16" data-id="element-200">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[var(--brand-charcoal)] uppercase tracking-wider mb-4" data-id="element-201">
            What Our Customers Say
          </h2>
        </div>

        {/* Horizontal scrolling container */}
        <div className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar gap-6 pb-8 -mx-4 px-4 sm:mx-0 sm:px-0" data-id="element-202">
          {testimonials.map((testimonial, index) => <Card key={index} className="min-w-[300px] md:min-w-[400px] flex-1 snap-center border-none shadow-lg bg-white" data-id="element-203">
              <CardContent className="p-8 flex flex-col h-full" data-id="element-204">
                <div className="flex gap-1 mb-6" data-id="element-205">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[var(--brand-gold)] text-[var(--brand-gold)]" data-id="element-206" />)}
                </div>
                <p className="text-gray-700 text-lg italic mb-8 flex-grow" data-id="element-207">
                  "{testimonial.quote}"
                </p>
                <div className="mt-auto" data-id="element-208">
                  <p className="font-bold text-[var(--brand-charcoal)]" data-id="element-209">
                    {testimonial.name}
                  </p>
                  <p className="text-gray-500 text-sm" data-id="element-210">{testimonial.city}</p>
                </div>
              </CardContent>
            </Card>)}
        </div>

        <div className="text-center mt-8" data-id="element-211">
          <a href="#" className="inline-flex items-center text-[var(--brand-gold)] font-medium hover:text-yellow-600 transition-colors underline underline-offset-4" data-id="element-212">
            Leave Us a Review
          </a>
        </div>
      </div>

      {/* CSS to hide scrollbar but keep functionality */}
      <style dangerouslySetInnerHTML={{
      __html: `
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `
    }} data-id="element-213" />
    </section>;
}